import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import { useEffect, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button/Button'
import { Loader } from 'core-components/library/loader'
import { Controller, isEmpty, ValidateInput } from 'core-components/library/validation'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'
import { IPartnerGroupAdditionalInfo } from '../../../models/IPartnerGroupAdditionalInfo'
import { Title } from '../../styledComponents/title/Title'
import { getVersionsCount } from '../helpers/getVersionsCount'

import { IAddNewVersion } from './models'

import styles from './AddNewVersionContent.module.scss'

interface IProps {
  partnerGroupInfo: IPartnerGroupAdditionalInfo
  fYear: number
  fQuarter: number
  partnerId: string
  eltType: EltType
  addNewVersion: (args: IAddNewVersion) => void
  wip?: boolean
}

export const AddNewVersionContent = ({
  partnerGroupInfo,
  fYear,
  addNewVersion,
  partnerId,
  fQuarter,
  wip,
  eltType,
}: IProps) => {
  const [versionSerialNumber, setVersionSerialNumber] = useState<number>(1)
  const [versionName, setVersionName] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const save = () => {
    addNewVersion({
      versionName,
      versionSerialNumber,
      fYear,
      partnerId,
      partnerGroupInfo,
      fQuarter,
      eltType,
    })
  }

  useEffect(() => {
    setIsLoading(true)
    getVersionsCount({ groupId: partnerGroupInfo.groupId, partnerId }).then((count) => {
      const vCount = (count || 0) + 1
      setVersionSerialNumber(vCount)
      setVersionName(`Version ${vCount}`)
      setIsLoading(false)
    })
  }, [partnerGroupInfo.groupId, partnerId])

  if (isLoading || wip) {
    return <Loader />
  }

  return (
    <Controller>
      <Title align={'center'} text={getFormedEltTranslation(`add-new-version-${eltType}`)} />
      <ValidateInput checkFn={isEmpty} value={versionName} onChange={setVersionName} />
      <div className={styles.btnWrapper}>
        <Button onClick={save} disabled={!versionName}>
          <Translation text={getFormedEltTranslation('save')} />
        </Button>
      </div>
    </Controller>
  )
}
